import CssStyle from "@/module/Form/Resources/CssStyle";

export default class StylesBuilder {
  private googleFonts: { [key: string]: string } = {
    "Alegreya Sans": "Alegreya Sans",
    Anton: "Anton",
    "Arbutus Slab": "Arbutus Slab",
    "Archivo Narrow": "Archivo Narrow",
    "Archivo Black": "Archivo Black",
    "Autour One": "Autour One",
    "Bree Serif": "Bree Serif",
    Capriola: "Capriola",
    "Clicker Script": "Clicker Script",
    Courgette: "Courgette",
    "Crete Round": "Crete Round",
    Dosis: "Dosis",
    Enriqueta: "Enriqueta",
    Exo: "Exo",
    Inder: "Inder",
    "Grand Hotel": "Grand Hotel",
    "Just Me Again Down Here": "Just Me Again Down Here",
    "Kaushan Script": "Kaushan Script",
    McLaren: "McLaren",
    "Mouse Memoirs": "Mouse Memoirs",
    "Noticia Text": "Noticia Text",
    "Noto Serif": "Noto Serif",
    "Open Sans": "Open Sans",
    "Open Sans Condensed": "Open Sans Condensed",
    Parisienne: "Parisienne",
    "Patrick Hand": "Patrick Hand",
    "Patrick Hand SC": "Patrick Hand SC",
    Ribeye: "Ribeye",
    Roboto: "Roboto",
    "Roboto Condensed": "Roboto Condensed",
    "Roboto Slab": "Roboto Slab",
    Signika: "Signika",
    Sacramento: "Sacramento",
    "Stint Ultra Condensed": "Stint Ultra Condensed",
    "Unica One": "Unica One",
    Ubuntu: "Ubuntu",
    "Ubuntu Condensed": "Ubuntu Condensed",
    Voces: "Voces",
    Poppins: "Poppins",
    Raleway: "Raleway",
  };

  private readonly stylesVariables: any;
  private readonly cssStyle: CssStyle | null;

  constructor(stylesVariables: any, cssStyle: CssStyle | null) {
    this.stylesVariables = stylesVariables;
    this.cssStyle = cssStyle;
  }

  async fillStylesVariables(): Promise<void> {
    if (!this.cssStyle || !this.cssStyle.enabled) {
      return;
    }
    const styling = this.cssStyle;

    if (styling.background_color) {
      this.stylesVariables["--background-color"] = styling.background_color;
    } else if (styling.background_color === null) {
      this.stylesVariables["--background-color"] = "transparent";
    }

    if (styling.text_size) {
      this.stylesVariables["--font-size"] = styling.text_size + "px";
    }

    if (styling.text_color) {
      this.stylesVariables["--color"] = styling.text_color;
    }

    if (styling.text_font) {
      this.stylesVariables["--font-family"] = styling.text_font;
      this.addFont(styling.text_font);
    }

    if (styling.input_color) {
      this.stylesVariables["--input-color"] = styling.input_color;
    }

    if (styling.sale_color) {
      this.stylesVariables["--sale-color"] = styling.sale_color;
    }

    if (styling.headline_background_color) {
      this.stylesVariables["--container-header-background-color"] =
        styling.headline_background_color;
    }

    if (styling.headline_size) {
      this.stylesVariables["--container-header-font-size"] =
        styling.headline_size + "px";
    }

    if (styling.headline_font) {
      this.stylesVariables["--container-header-font-family"] =
        styling.headline_font;
      this.addFont(styling.headline_font);
    }

    if (styling.headline_color) {
      this.stylesVariables["--container-header-color"] = styling.headline_color;
    }

    if (styling.order_bump_text_size) {
      this.stylesVariables["--order-bump-container-header-font-size"] =
        styling.order_bump_text_size + "px";
    }

    if (styling.order_bump_text_color) {
      this.stylesVariables["--order-bump-container-header-color"] =
        styling.order_bump_text_color;
    }

    if (styling.order_bump_border_background_color) {
      this.stylesVariables["--order-bump-container-content-background-color"] =
        styling.order_bump_border_background_color;
    }

    if (styling.order_bump_border_line_color) {
      this.stylesVariables["--order-bump-container-header-background-color"] =
        styling.order_bump_border_line_color;
    }

    if (styling.order_bump_border_line_style) {
      this.stylesVariables["--order-bump-container-border-style"] =
        styling.order_bump_border_line_style;
    }

    if (styling.order_bump_border_line_width) {
      this.stylesVariables["--order-bump-container-border-width"] =
        styling.order_bump_border_line_width + "px";
    }

    if (styling.order_bump_border_item_background_color) {
      this.stylesVariables[
        "--order-bump-container-content-item-background-color"
      ] = styling.order_bump_border_item_background_color;
    }

    this.stylesVariables["--order-bump-item-arrow-display"] =
      styling.order_bump_show_arrow ? "inherit" : "none";

    if (styling.button_font) {
      this.stylesVariables["--submit-button-font-family"] = styling.button_font;
      this.addFont(styling.button_font);
    }

    if (styling.button_corner_radius) {
      this.stylesVariables["--submit-button-border-radius"] =
        styling.button_corner_radius + "px";
    }

    if (styling.button_color) {
      this.stylesVariables["--submit-button-background-color"] =
        styling.button_color;
    }

    if (styling.button_text_color) {
      this.stylesVariables["--submit-button-text-color"] =
        styling.button_text_color;
    }

    if (styling.button_size) {
      this.stylesVariables["--submit-button-font-size"] =
        styling.button_size + "px";
    }
  }

  private addFont(font: string): void {
    if (!this.googleFonts.hasOwnProperty(font)) {
      return;
    }

    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href =
      "https://fonts.googleapis.com/css?family=" +
      encodeURIComponent(this.googleFonts[font]);
    link.type = "text/css";
    document.getElementsByTagName("head")[0].appendChild(link);
  }
}
